/** Letters in any script and spaces; no digits or symbols */
const ADMIN_NAME_PATTERN = /^[\p{L}\s]+$/u;

export function isValidAdminName(name: string): boolean {
  const trimmed = name.trim();
  if (!trimmed) return false;
  return ADMIN_NAME_PATTERN.test(trimmed);
}
